import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ isSidebarOpen, onToggle }) {
    const location = useLocation();

    // Sidebar items
    const sidebarItems = [
        { name: 'Dashboard', path: '/dashboard', icon: '/images/png/sidebar/dashboard.png' },
        { name: 'Tips', path: '/tips', icon: '/images/png/sidebar/tips.png' },
        { name: 'Calendar', path: '/calendar', icon: '/images/png/sidebar/calendar.png' },
        { name: 'Users', path: '/user', icon: '/images/png/sidebar/user.png' },
        // { name: 'Options', path: '/options', icon: '/images/png/sidebar/options.png' },
        { name: 'FAQs', path: '/faq', icon: '/images/png/sidebar/faq.png' },
        // { name: 'CMS', path: '/cms', icon: '/images/png/sidebar/cms.png' },
        { name: 'Contact Enquiry', path: '/contact', icon: '/images/png/sidebar/contacts.png' },
        { name: 'Partner Enquiry', path: '/partner', icon: '/images/png/sidebar/partner.png' },
        { name: 'Recipe Blogs', path: '/blogs', icon: '/images/png/sidebar/blog.png' },
        { name: 'Products', path: '/products', icon: '/images/png/sidebar/products.png' },
        { name: 'Broadcast Notifications', path: '/broadcast-notification', icon: '/images/png/sidebar/broadcast.png' },
        { name: 'Subscriptions', path: '/subscription', icon: '/images/png/sidebar/subscription.png' },
        { name: 'Coupon Code', path: '/coupon-code', icon: '/images/png/sidebar/coupon.png' },
        { name: 'Category Management', path: '/category', icon: '/images/png/sidebar/coupon.png' },
        // { name: 'Website Enquiry', path: '/website-enquiry', icon: '/images/png/sidebar/website-enquiry.png' },
        // { name: 'Settings', path: '/settings', icon: '/images/png/sidebar/settings.png' },
        { name: 'Testimonial', path: '/testimonial', icon: '/images/png/sidebar/settings.png' },
        { name: 'SMS Leads', path: '/sms-lead', icon: '/images/png/sidebar/sms-lead.png' },
        { name: 'AI Chat', path: '/ai-chat', icon: '/images/png/sidebar/ai-chat.png' },
        { name: 'News Letter', path: '/news-letter',icon: '/images/png/sidebar/news.png'  }
        // Add more items here as needed
    ];

    return (
        <aside className={`${isSidebarOpen ? 'active' : ''}`}>
            <img onClick={onToggle} className='toggle toggle-arrow d-xl-none' width={40} src="/images/png/close-circle.png" alt="" />
            <img className='side-logo' src={`${isSidebarOpen ? '/images/logo/logo-sm.png' : '/images/logo/logo.png'}`} alt="" />
            <ul>
                {sidebarItems.map((item) => (
                    <li key={item.name}>
                        <Link
                            to={item.path}
                            className={`d-flex align-items-center gap-2 ${location.pathname === item.path || location.pathname.startsWith(item.path) ? 'active' : ''
                                }`}
                        >
                            <img src={item.icon} width={24} alt={item.name} />
                            <span>{item.name}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </aside>
    );
}

export default Sidebar;
